import { trpc } from '@/shared/api';

interface PlainQuoteRequestFormQueryInput {
  readonly productId: string;
  readonly colorOptionId: string;
}

interface PlainQuoteRequestFormQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 일반 견적 요청 정보(quotes.getPlainRequestForm, 일반 견적 설계 §5-3) — 편집영역 없는 상품을 디자인 없이 요청하는 폼.
 * 비회원 폼 칸(상품·색상 이름·최소 수량·구간 단가·배송비 설정)에 회원 기본 담당자명이 더해진다(비회원은 빈 문자열).
 * 요청 불가(상품 숨김·편집영역 있음·색상 공급 불가)는 다시 물어도 같아 재시도하지 않는다.
 */
export const usePlainQuoteRequestFormQuery = (
  { productId, colorOptionId }: PlainQuoteRequestFormQueryInput,
  options: PlainQuoteRequestFormQueryOptions = {},
) =>
  trpc.quotes.getPlainRequestForm.useQuery(
    { productId, colorOptionId },
    { enabled: options.enabled ?? true, retry: false },
  );
